const MonEquipe = () => {
    return (
        <div>
            <h1>Mon équipe</h1>
        </div>
    );
};

export default MonEquipe;
